// src/pages/VentWindow.jsx
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function VentWindow() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('단창용');

  const tabList = [
    '단창용',
    '대형창문용',
    '다연창용',
    '슬라이딩 단창용',
    '슬라이딩 이중창용',
    '전, 수동 환기창용',
    '천장, 경사각의 창문용'
  ];

  return (
    <div className="text-gray-800">
      {/* 배경 이미지 Hero 섹션 */}
      <section className="relative h-[60vh] bg-[url('hero-bg.jpg')] bg-cover bg-center flex items-center justify-center">
        <div className="absolute inset-0 bg-black bg-opacity-50" />
        <div className="relative z-10 text-center px-4 flex flex-col justify-center h-full">
          <h1 className="text-4xl md:text-5xl font-bold text-white">제품소개</h1>
          <p className="mt-4 text-white text-lg md:text-xl">JDWinTech의 대표 제품들을 소개합니다.</p>

          {/* 하단 탭 메뉴 */}
          <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-40 flex justify-center">
            <div className="flex">
              <Link to="/products/smoke" className={`rounded-tl-md px-6 py-3 text-sm md:text-base font-medium ${location.pathname === '/products/smoke' ? 'bg-white text-blue-800' : 'text-white hover:bg-white hover:text-blue-800'}`}>배연창</Link>
              <Link to="/products/vent" className={`px-6 py-3 text-sm md:text-base font-medium ${location.pathname === '/products/vent' ? 'bg-white text-blue-800' : 'text-white hover:bg-white hover:text-blue-800'}`}>환기창</Link>
              <Link to="/products/closer" className={`rounded-tr-md px-6 py-3 text-sm md:text-base font-medium ${location.pathname === '/products/closer' ? 'bg-white text-blue-800' : 'text-white hover:bg-white hover:text-blue-800'}`}>창문형 자동폐쇄장치</Link>
            </div>
          </div>
        </div>
      </section>

      {/* 제품 설명 섹션 */}
      <section className="py-20 px-4 md:px-20 max-w-6xl mx-auto">
        <h2 className="text-2xl font-bold text-blue-800 mb-6 text-center">환기창</h2>

        {/* 탭 버튼 */}
        <div className="inline-flex justify-center overflow-hidden rounded-md border border-gray-300 mb-10">
          {tabList.map((label) => (
            <button
              key={label}
              onClick={() => setActiveTab(label)}
              className={`px-6 py-3 text-sm md:text-base font-medium min-w-[150px] text-gray-700 hover:bg-gray-100 focus:z-10 ${activeTab === label ? 'bg-indigo-800 text-white' : ''}`}
            >
              {label}
            </button>
          ))}
        </div>

        {tabList.map((label, idx) => (
          activeTab === label && (
            <div key={label} className="space-y-12">
                <img src={`/images/smoke/${idx + 1}.jpg`} alt={`${label} 이미지`} className="w-full max-w-3xl mx-auto mb-6 rounded shadow" />
              {/* 기능 */}
              <div className="text-center">
                <h3 className="text-3xl font-bold text-gray-800 mb-2">기능</h3>
                <p className="text-red-600 font-semibold mb-4">특허 등록 (제10-2175022호)</p>
                <ul className="text-left list-disc pl-5 max-w-3xl mx-auto space-y-2">
                  <li>음성인식을 통해 받은 구어체 TEXT를 주소에 맞게 정제, 치환</li>
                  <li>주소에 특화된 알고리즘을 통해 배송/방문 가능한 주소여부 판단</li>
                  <li>추가 질의 및 확인</li>
                  <li>자동처리 (상담사의 검증 절차 불필요)</li>
                </ul>
              </div>

              {/* 특장점 */}
              <div>
                <h3 className="text-3xl font-bold text-center text-gray-800 mb-8">특장점</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
                  {['다양한 음성인식 Tool과 연계 경험 및 특성 처리','주소에 포함된 자연어 정제','대화형 시나리오 제공','무인 주문, 무인 서비스 자동'].map((text, i) => (
                    <div key={i} className="text-center border p-6">
                      <div className="mb-4 h-12 bg-gray-200" />
                      <p>{text}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* 도입배경 */}
              <div>
                <h3 className="text-3xl font-bold text-center text-gray-800 mb-8">도입배경</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
                  {['주소 인식의 어려움으로 재문의 발생/상담시간 지연','음성인식 Tool 적용에도 상담원 검수 필요','배송지 주소 수작업 처리','지역별 다양한 고객 민원'].map((text, i) => (
                    <div key={i} className="text-center border p-6">
                      <div className="mb-4 h-12 bg-gray-200" />
                      <p>{text}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* 도입효과 */}
              <div className="text-center">
                <h3 className="text-3xl font-bold text-gray-800 mb-8">도입효과</h3>
                <ul className="text-left list-disc pl-5 max-w-3xl mx-auto space-y-2">
                  <li>상담 시간 단축</li>
                  <li>주소 처리 자동화 기능</li>
                  <li>상담원 대비 주소 오류 인지율 감소</li>
                  <li>상담원 주소 인지 불편 감소</li>
                  <li>배송지 주소 정확도 향상</li>
                </ul>
              </div>

              {/* 도입사례 */}
              <div>
                <h3 className="text-3xl font-bold text-center text-gray-800 mb-8">도입사례</h3>
                <div className="h-64 bg-gray-200 rounded shadow-md max-w-4xl mx-auto" />
              </div>

              {/* 활용방안 */}
              <div>
                <h3 className="text-3xl font-bold text-center text-gray-800 mb-8">활용방안</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
                  {['홈쇼핑 배송지 주소 서비스','주소가 필요한 무인 서비스','상담사 주소 Assist 서비스','지역 구분 서비스'].map((text, i) => (
                    <div key={i} className="text-center border p-6">
                      <div className="mb-4 h-12 bg-gray-200" />
                      <p>{text}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )
        ))}
      </section>
    </div>
  );
}

export default VentWindow;